import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="bg-[#1a1a1a] text-white py-12 sm:py-16">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 sm:gap-12 mb-8 sm:mb-12">
          <div>
            <div className="flex flex-col leading-none mb-4 sm:mb-6">
              <span style={{ fontFamily: "'Georgia', 'Times New Roman', serif", letterSpacing: '0.18em' }} className="text-white font-bold text-2xl tracking-widest uppercase">LIKES</span>
              <span style={{ fontFamily: "'Georgia', 'Times New Roman', serif", letterSpacing: '0.22em' }} className="text-white text-[9px] font-medium tracking-[0.22em] uppercase mt-0.5">Co, Ltd</span>
            </div>
            <p className="text-white/70 text-sm leading-relaxed mb-4 whitespace-pre-line">{t('footer.tagline')}</p>
            <p className="text-white/60 text-xs">株式会社LIKES<br />{t('footer.representative')}</p>
          </div>
          <div>
            <h3 className="text-white font-bold mb-4 text-sm sm:text-base">{t('footer.quicklinks')}</h3>
            <ul className="space-y-2 sm:space-y-3">
              <li><a href="#vision" className="text-white/70 hover:text-white transition-colors duration-200 text-sm cursor-pointer">{t('footer.links.vision')}</a></li>
              <li><a href="#services" className="text-white/70 hover:text-white transition-colors duration-200 text-sm cursor-pointer">{t('footer.links.services')}</a></li>
              <li><a href="#csr" className="text-white/70 hover:text-white transition-colors duration-200 text-sm cursor-pointer">{t('footer.links.csr')}</a></li>
              <li><Link to="/company" className="text-white/70 hover:text-white transition-colors duration-200 text-sm cursor-pointer">{t('footer.links.company')}</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="text-white font-bold mb-4 text-sm sm:text-base">{t('footer.services')}</h3>
            <ul className="space-y-2 sm:space-y-3">
              <li><Link to="/services/cashless" className="text-white/70 hover:text-white transition-colors duration-200 text-sm cursor-pointer">{t('footer.links.cashless')}</Link></li>
              <li><Link to="/services/consulting" className="text-white/70 hover:text-white transition-colors duration-200 text-sm cursor-pointer">{t('footer.links.consulting')}</Link></li>
              <li><Link to="/csr" className="text-white/70 hover:text-white transition-colors duration-200 text-sm cursor-pointer">{t('footer.links.youth')}</Link></li>
            </ul>
            <h3 className="text-white font-bold mt-6 sm:mt-8 mb-4 text-sm sm:text-base">{t('footer.related')}</h3>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <a href="https://www.ikimonogakari.jp/" target="_blank" rel="noopener noreferrer nofollow" className="inline-block cursor-pointer">
                  <div className="bg-white rounded-lg px-3 py-2 inline-block hover:opacity-90 transition-opacity duration-200">
                    <img src="https://static.readdy.ai/image/26970d9518e2e09002ea7ff933ab8760/c503ce79136b664197eba3206c0762d8.jpeg" alt="ペットシッターサービス いきものがかり" className="h-12 w-auto object-contain" />
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-white/10 pt-6 sm:pt-8 text-center">
          <p className="text-white/50 text-xs sm:text-sm">{t('footer.copyright', { year: new Date().getFullYear() })}</p>
        </div>
      </div>
    </footer>
  );
}
